import { combineReducers } from 'redux';
import viewAlertReducer from './viewAlert';

const rootReducers = combineReducers({  viewAlertReducer });

export default rootReducers;